// ================================
// SMOOTH WHEEL CONTROLS
// ================================
$ = jQuery;

function WheelControls(slider) {
  let wheelTimeout = null;
  let delta = 0;

  function wheelHandler(e) {
    e.preventDefault();
    delta += e.deltaY;

    if (!wheelTimeout) {
      wheelTimeout = setTimeout(() => {
        if (delta > 40) slider.next();
        if (delta < -40) slider.prev();
        delta = 0;
        wheelTimeout = null;
      }, 120);
    }
  }

  slider.on("created", () => {
    slider.container.addEventListener("wheel", wheelHandler, { passive: false });
  });
}

// ================================
// NAVIGATION (ARROWS + DOTS + KEYS)
// ================================
function Navigation(slider) {
  let wrapper, dots, arrowLeft, arrowRight;

  function createDiv(className) {
    const div = document.createElement("div");
    className.split(" ").forEach((c) => div.classList.add(c));
    return div;
  }

  function remove(el) {
    el && el.parentNode && el.parentNode.removeChild(el);
  }

  function buildWrapper() {
    wrapper = createDiv("navigation-wrapper");
    slider.container.parentNode.appendChild(wrapper);
    wrapper.appendChild(slider.container);
  }

  function buildArrows() {
    arrowLeft = createDiv("arrow arrow--left");
    arrowRight = createDiv("arrow arrow--right");

    arrowLeft.innerHTML = `
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
        <path d="M15 18L9 12L15 6" stroke="white" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;

    arrowRight.innerHTML = `
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
        <path d="M9 6L15 12L9 18" stroke="white" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;

    arrowLeft.addEventListener("click", () => slider.prev());
    arrowRight.addEventListener("click", () => slider.next());

    wrapper.appendChild(arrowLeft);
    wrapper.appendChild(arrowRight);

    setupHoverIntent();
  }

  // ✅ Get heading from each slide (.hero-slide__title)
  function getSlideTitle(idx) {
    const slideEl = slider.slides[idx]; // keen gives real slide elements
    if (!slideEl) return `Slide ${idx + 1}`;

    const titleEl = slideEl.querySelector(".hero-slide__title");
    const title = titleEl ? titleEl.textContent.trim() : "";
    return title || `Slide ${idx + 1}`;
  }

  function buildDots() {
    dots = createDiv("dots");

    slider.track.details.slides.forEach((_slide, idx) => {
      const dot = createDiv("dot");

      // ✅ Put heading text in dot
      const label = getSlideTitle(idx);
      dot.textContent = label;

      // Accessibility niceties
      dot.setAttribute("role", "button");
      dot.setAttribute("tabindex", "0");
      dot.setAttribute("aria-label", `Go to: ${label}`);

      dot.addEventListener("click", () => slider.moveToIdx(idx));

      // Allow Enter/Space on focused dot
      dot.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          slider.moveToIdx(idx);
        }
      });

      dots.appendChild(dot);
    });

    wrapper.appendChild(dots);
  }

  function updateUI() {
    const rel = slider.track.details.rel;

    // If loop:true, disabling arrows doesn't make sense.
    // Keep your classes if you still want visual feedback, but rel boundaries won't apply.
    if (arrowLeft && arrowRight && slider.options.loop !== true) {
      arrowLeft.classList.toggle("arrow--disabled", rel === 0);
      arrowRight.classList.toggle(
        "arrow--disabled",
        rel === slider.track.details.slides.length - 1
      );
    }

    Array.from(dots.children).forEach((dot, idx) => {
      dot.classList.toggle("dot--active", idx === rel);
    });
  }

  function setupHoverIntent() {
    const container = slider.container;
    const EDGE_PERCENT = 0.2;

    function showLeft() {
      arrowLeft.classList.add("is-visible");
      arrowRight.classList.remove("is-visible");
    }

    function showRight() {
      arrowRight.classList.add("is-visible");
      arrowLeft.classList.remove("is-visible");
    }

    function hideAll() {
      arrowLeft.classList.remove("is-visible");
      arrowRight.classList.remove("is-visible");
    }

    container.addEventListener("mousemove", (e) => {
      const rect = container.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const edgeWidth = rect.width * EDGE_PERCENT;

      if (x < edgeWidth) showLeft();
      else if (x > rect.width - edgeWidth) showRight();
      else hideAll();
    });

    container.addEventListener("mouseleave", hideAll);

    arrowLeft.addEventListener("mouseenter", showLeft);
    arrowRight.addEventListener("mouseenter", showRight);
    arrowLeft.addEventListener("mouseleave", hideAll);
    arrowRight.addEventListener("mouseleave", hideAll);
  }

  // ✅ Keyboard navigation (left/right arrows)
  function bindKeyboard() {
    function onKeyDown(e) {
      // Don't hijack typing in inputs/textareas/selects/contenteditable
      const t = e.target;
      const tag = t && t.tagName ? t.tagName.toLowerCase() : "";
      const isTyping =
        tag === "input" ||
        tag === "textarea" ||
        tag === "select" ||
        (t && t.isContentEditable);

      if (isTyping) return;

      if (e.key === "ArrowLeft") {
        e.preventDefault();
        slider.prev();
      }
      if (e.key === "ArrowRight") {
        e.preventDefault();
        slider.next();
      }
    }

    // Bind once and remember handler for cleanup
    slider._tpKeyHandler = onKeyDown;
    window.addEventListener("keydown", onKeyDown);
  }

  function unbindKeyboard() {
    if (slider._tpKeyHandler) {
      window.removeEventListener("keydown", slider._tpKeyHandler);
      slider._tpKeyHandler = null;
    }
  }

  slider.on("created", () => {
    buildWrapper();
    buildArrows();
    buildDots();
    updateUI();
    bindKeyboard();
  });

  slider.on("slideChanged", updateUI);

  slider.on("destroyed", () => {
    unbindKeyboard();
    remove(wrapper);
    remove(dots);
    remove(arrowLeft);
    remove(arrowRight);
  });
}

// ================================
// KEEN SLIDER INIT
// ================================
// const slider = new KeenSlider(
//   "#my-keen-slider",
//   {
//     loop: true,
//     rubberband: true,
//     mode: "snap",
//     defaultAnimation: { duration: 1400 },
//     renderMode: "performance",
//     breakpoints: {
//       "(min-width: 400px)": {
//         slides: { origin: "center", perView: 1, spacing: 0 },
//       },
//       "(min-width: 1000px)": {
//         slides: { origin: "center", perView: 1.4, spacing: 0 },
//       },
//     },
//   },
//   [WheelControls, Navigation]
// );

// ================================
// ACTIVE SLIDE CLASS
// ================================
// slider.on("detailsChanged", (s) => {
//   s.slides.forEach((slide, idx) => {
//     const details = s.track.details.slides[idx];
//     slide.classList.toggle("active", details.portion > 0.9);
//   });
// });

$(document).ready(function () {

  const $carousel = $('.owl-carousel');
  const $tabs = $('.text-tabs li');
  let isScrolling = false;

  // INIT OWL
  $carousel.owlCarousel({
    loop: true,
    center: true,
    dots: false,
    nav: false,
    smartSpeed: 1000,
    mouseDrag: true,
    touchDrag: true,
    responsive: {
      0: { items: 1 },
      800: { items: 1.3, margin: 40 },
      1300: { items: 1.3, margin: 80 }
    }
  });

  // TAB → SLIDER
  $tabs.on('click', function () {
    const index = $(this).data('slide');
    if ($(this).hasClass('active')) return;

    $tabs.removeClass('active');
    $(this).addClass('active');

    $carousel.trigger('to.owl.carousel', [index, 500, true]);
  });

  // DRAG / SCROLL → TAB (AFTER SNAP)
  $carousel.on('translated.owl.carousel', function (event) {
    const total = event.item.count;
    const clones = event.relatedTarget._clones.length / 2;

    let index = event.item.index - clones;
    index = ((index % total) + total) % total;

    $tabs.removeClass('active');
    $tabs.eq(index).addClass('active');

    isScrolling = false;
  });

  // 🖱️ MOUSE WHEEL + TRACKPAD SUPPORT
  $carousel.on('wheel', '.owl-stage', function (e) {
    e.preventDefault();

    if (isScrolling) return;
    isScrolling = true;

    if (e.originalEvent.deltaY > 0) {
      $carousel.trigger('next.owl.carousel');
    } else {
      $carousel.trigger('prev.owl.carousel');
    }
  });

  // $(window).on("scroll", function () {
  //   let pos = $(window).scrollTop();
  //   if (pos > 20) {
  //     $(".hero-carousel-section").css("height", "90vh");
  //   } else {
  //     $(".hero-carousel-section").css("height", "100vh");
  //   }
  // });
});